// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2UahZ","rootSuccess":"CompleteLink_rootSuccess__nd9oC","rootFailure":"CompleteLink_rootFailure__3xI2l","isDisabled":"CompleteLink_isDisabled__3T4j9"};